import React from 'react';
import { Typography } from '@mui/material';
import { useAppSelector } from '../../../../../app/hooks';

interface StepOrderBadgeProps {
  index: number;
}

export const StepOrderBadge: React.FC<StepOrderBadgeProps> = ({ index }) => {
  const step = useAppSelector((state) => state.workflow.currentWorkflow?.steps[index]);

  if (!step) return null;

  return (
    <Typography
      sx={{
        backgroundColor: '#3b82f6',
        color: '#fff',
        borderRadius: '50%',
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        fontSize: '0.875rem',
      }}
    >
      {step.order}
    </Typography>
  );
};

export default StepOrderBadge;
